import React,{useState,useEffect} from 'react'
import Title from '../../../../components/panelcontrols/paneltitle'
import Table from './orderTable'
import Functions from './functions'
import Button from '../../../../components/panelcontrols/panelbuttonmain'
import { ToastContainer, toast } from 'react-toastify';

const Index = () => {
  const [list,setList] = useState([]);
  const [page,setPage] = useState(1);
  const [paginationInfo,setPaginationInfo] = useState({ pages: 1, total: 0 });
  const limit = 20;

  useEffect(()=>{
    Functions.Get(setList, setPaginationInfo, page, limit);
  },[page])

  return (
    <div className='labadmin_order_list_container'>
      <Title Value={'Orders'}/>
      <div style={{display:"flex",justifyContent:"flex-end"}}>
        <div style={{width:"25%"}}>
          <Button Value={'Add New'} Action={()=>{
            document.location.replace('/doctor/orders/new');
          }}/>
        </div>
      </div>
      <Table List={list}/>
      <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'12px',padding:'16px'}}>
        <button
          onClick={()=>setPage(p=>p-1)}
          disabled={page<=1}
          style={{padding:'6px 16px',cursor:page<=1?'not-allowed':'pointer',opacity:page<=1?0.5:1,borderRadius:'4px',border:'1px solid #ccc'}}>
          Previous
        </button>
        <span style={{fontSize:'14px'}}>Page {page} of {paginationInfo.pages || 1} &nbsp;|&nbsp; Total: {paginationInfo.total || 0}</span>
        <button
          onClick={()=>setPage(p=>p+1)}
          disabled={page>=(paginationInfo.pages||1)}
          style={{padding:'6px 16px',cursor:page>=(paginationInfo.pages||1)?'not-allowed':'pointer',opacity:page>=(paginationInfo.pages||1)?0.5:1,borderRadius:'4px',border:'1px solid #ccc'}}>
          Next
        </button>
      </div>
      <ToastContainer/>
    </div>
  )
}

export default Index
